import { RootState } from "../../../reducers";
import { getPpuFlag, isPayPerUseSelector } from "../../../selector";

export const getDisplayLocationViewToggle = (state: RootState) => state.locationRouter?.displayHeader;
export const getLocationRouterView = (state: RootState) => state.locationRouter.view;
export const getUseNewLocationSelectionUI = (state: RootState) => state.locationRouter.useNewUI;
export const getUserIsPPU = (state: RootState) => {
  const ppuFlag = getPpuFlag(state) === "Y";
  const ppuEnabled = isPayPerUseSelector(state);

  return ppuFlag && ppuEnabled;
};
